import { render, staticRenderFns } from "./EditorLayout.vue?vue&type=template&id=769e985e&scoped=true&"
import script from "./EditorLayout.vue?vue&type=script&lang=js&"
export * from "./EditorLayout.vue?vue&type=script&lang=js&"
import style0 from "./EditorLayout.vue?vue&type=style&index=0&id=769e985e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769e985e",
  null
  
)

export default component.exports